export const environment = {
    production: false,
    BASE_URL : 'https://dev-api.coachee360.com/api/v1'
};